import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosInstance } from "../../utils/axios-instance";

export const postApplication = createAsyncThunk(
    "application/postApplication",
    async (initialApplication) => {
        const dateConverter = (jsDate) => {
            // https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/date
            // For JS input class, the displayed date is formatted based on the locale of the user's browser, BUT THE PARSED VALUE IS ALWAYS FORMATTED yyyy-mm-dd.
            // BUT FileMaker Date field expects mm/dd/yyyy.
            // This block of code transforms the input date into a FM friendly one.
            //     yyyy-mm-dd => mm/dd/yyyy
            // ex: 2024-01-17 => 01/17/2024
            let year = jsDate.slice(0, 4);
            let month = jsDate.slice(5, 7);
            let day = jsDate.slice(8, 10);
            // jsDate.App_RecdDate = month + "/" + day + "/" + year;
            let fmDate = month + "/" + day + "/" + year;

            return fmDate;
        };

        // const fd = new FormData();
        // const { forms } = initialApplication;

        // forms.forEach((file) => {
        //     fd.append("upload", file);
        // });

        // delete initialApplication.forms;

        // for (const [key, value] of Object.entries(initialApplication)) {
        //     fd.append(key, value);
        // }

        // for (var [key, value] of fd.entries()) {
        // }

        try {
            const response = await axiosInstance({
                method: "post",
                url: "/application",
                // headers: {
                //     'Content-Type': 'application/json'
                // },
                data: initialApplication
            });

            let responseValues = {
                ...response.data,
                data: {
                    App_Date_Recd: dateConverter(
                        initialApplication.signatureDate
                    ),
                    App_REQID: initialApplication.requisitionID,
                    App_IAID: initialApplication.individualAssessmentID, // INDIVIDUAL ASSESSMENT SUBJECT TO CHANGE
                    References: initialApplication.references,
                    PositionNumber: initialApplication.positionNumber,
                    PositionTitle: initialApplication.positionTitle,
                    Location: initialApplication.location,
                    ClosingDate: initialApplication.closingDate,
                    SubmissionDate: initialApplication.signatureDate,
                    App_Status: "Pending",
                    App_WorkHours: initialApplication.workHours,
                    App_WorkDays: initialApplication.workDays,
                    App_PayRate: initialApplication.payRate,
                    App_EmploymentType: initialApplication.employmentType,
                    App_Sensitive: initialApplication.sensitive,
                    App_Department: initialApplication.department,
                    App_Location: initialApplication.location,
                    Skills1: initialApplication.jobRelatedSkill1,
                    Skills2: initialApplication.jobRelatedSkill2,
                    Skills3: initialApplication.jobRelatedSkill3,
                    Skills4: initialApplication.jobRelatedSkill4,

                    Trainings1_ExpirationDate: initialApplication.jobRelatedTrainingExpirationDate1,
                    Trainings1_From: initialApplication.jobRelatedTrainingFrom1,
                    Trainings1_Name: initialApplication.jobRelatedTrainingName1,
                    Trainings1_To: initialApplication.jobRelatedTrainingTo1,

                    Trainings2_ExpirationDate: initialApplication.jobRelatedTrainingExpirationDate2,
                    Trainings2_From: initialApplication.jobRelatedTrainingFrom2,
                    Trainings2_Name: initialApplication.jobRelatedTrainingName2,
                    Trainings2_To: initialApplication.jobRelatedTrainingTo2,

                    Trainings3_ExpirationDate: initialApplication.jobRelatedTrainingExpirationDate3,
                    Trainings3_From: initialApplication.jobRelatedTrainingFrom3,
                    Trainings3_Name: initialApplication.jobRelatedTrainingName3,
                    Trainings3_To: initialApplication.jobRelatedTrainingTo3,

                    Trainings4_ExpirationDate: initialApplication.jobRelatedTrainingExpirationDate4,
                    Trainings4_From: initialApplication.jobRelatedTrainingFrom4,
                    Trainings4_Name: initialApplication.jobRelatedTrainingName4,
                    Trainings4_To: initialApplication.jobRelatedTrainingTo4,

                    Trainings5_ExpirationDate: initialApplication.jobRelatedTrainingExpirationDate5,
                    Trainings5_From: initialApplication.jobRelatedTrainingFrom5,
                    Trainings5_Name: initialApplication.jobRelatedTrainingName5,
                    Trainings5_To: initialApplication.jobRelatedTrainingTo5,

                    Trainings6_ExpirationDate: initialApplication.jobRelatedTrainingExpirationDate6,
                    Trainings6_From: initialApplication.jobRelatedTrainingFrom6,
                    Trainings6_Name: initialApplication.jobRelatedTrainingName6,
                    Trainings6_To: initialApplication.jobRelatedTrainingTo6,

                    Reference1:  initialApplication.Reference1,  
                    Reference1Address:  initialApplication.Reference1Address, 
                    Reference1Phone:  initialApplication.Reference1Phone, 
                    Reference2:  initialApplication.Reference2, 
                    Reference2Address:  initialApplication.Reference2Address, 
                    Reference2Phone:  initialApplication.Reference2Phone, 
                    Reference3:  initialApplication.Reference3, 
                    Reference3Address:  initialApplication.Reference3Address, 
                    Reference3Phone:  initialApplication.Reference3Phone, 
                }
            };
            return responseValues;
        } catch (error) {
            console.error(error);
            return Promise.reject(error);
        }
    }
);
